export default {"src":"/_next/static/media/unavailable-products-icon.edfb39c7.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};